// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Arrow_wrapper__2iibI","img":"Arrow_img__2Xsww","left":"Arrow_left__39Q-u","right":"Arrow_right__2s6fR","show":"Arrow_show__2Fw4-","hide":"Arrow_hide__18igT"};